import { type FunctionComponent } from 'react';
import { ReactComponent as BlackStripGenericSVG } from '../../assets/icons/mevo/medicine/tarjapreta_generico.svg';
import IconPattern, { IconProps } from './_IconPattern';

const MedicineBlackStripGenericIcon: FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={BlackStripGenericSVG} variantPlaces={[]} {...props} />;
};

export default MedicineBlackStripGenericIcon;
